import React from "react";
import "../index.css"
import "../../styles/style.css"

import { Button } from "primereact/button";

import prod_image from "../../../../images/no_image_small.png"


const CartItems = (props) => {
    const { cartItems, products, updateCartItems } = props

    const handleQuantityChange = (event, selectedItem) => {
        cartItems.map(eachCartItem => {
            if(eachCartItem.buyerPOItemId === selectedItem.buyerPOItemId){
                eachCartItem.quantity = event.target.value
                updateCartItems("CHANGE", eachCartItem)
            }
        })
    }

    return(
        <div>
            <div className="row cart-items-container">
                <div className="col-s12 pt-2" >
                    <div className="flex flex-row justify-content-between py-1">
                        <h5 className="m-2 font-bold">Shopping Cart</h5>
                        <h5 className="m-2 font-bold">({cartItems.length} Items)</h5>
                    </div>
                    {
                        cartItems.length == 0 ? <h2 style={{color : 'red' }}>No Items in Cart</h2> :
                            <table className="product-cart-table w-full mt-3">
                            <tbody>
                                {
                                    cartItems.map((item, index) => {
                                        const relatedProduct = products.find(eachProduct => eachProduct.buyerPOItemId === item.buyerPOItemId)

                                        let isProductExhausted = true
                                        if(relatedProduct){
                                            if(relatedProduct.availableQty > 0){
                                                isProductExhausted = false
                                            }
                                        }
                                        return (
                                            <>
                                            <tr className="">
                                                <td className=' p-3 line-height-3 flex flex-row ' style={{width: "580px", paddingLeft: '5px', paddingRight:'7px',paddingBottom:"5px"}}>
                                                    <div className=''>
                                                        <p style={{margin: 0, marginTop: '25px', marginRight: '10px'}}>{index + 1}</p>
                                                    </div>
                                                    <div className='pr-2'>
                                                        <img style={{height: '60px', width: '77px'}} className="catalogue-request-product-image" src={ prod_image } />
                                                    </div>
                                                    <div>
                                                        <h5 style={{margin: 0, fontSize: '14px', fontWeight: '600', marginTop: '4px', marginBottom:"8px", color:"#222"}}>{relatedProduct.companyProdName}</h5>
                                                        <p style={{margin: 0, fontSize: '13px', color: 'grey'}} className="flex flex-wrap mb-1"><span className="text-title">{relatedProduct.companyProdSpec}</span></p>
                                                        <p style={{margin: 0, fontSize: '13px', color: 'grey'}} className="text-title">ERP Code: {relatedProduct.companyERPCode}</p>
                                                    </div>
                                                </td>
                                                <td className="line-height-3" style={{width: "20%", paddingLeft: '5px'}}>
                                                        { 
                                                            isProductExhausted ?
                                                            <span style={{color: "red"}}>EXHAUSTED</span>
                                                            :
                                                            <div className='product-cart-quantity-block'>
                                                                <div className='product-cart-minus-btn' onClick={() => updateCartItems(item.quantity === 1 ? "REMOVE" : "DECREASE", item)} ><i className="pi pi-minus"></i></div>
                                                                <input
                                                                    type="text"
                                                                    name= "quantity"
                                                                    id="quantity"
                                                                    placeholder = "Quantity"
                                                                    value={item.quantity}
                                                                    onChange={(event) => handleQuantityChange(event, item)}
                                                                    onBlur={() => updateCartItems("SET", item)}
                                                                    className="product-cart-quantity-input"
                                                                /> 
                                                                <div className='product-cart-plus-btn' onClick={() => updateCartItems("INCREASE", item)}><i className="pi pi-plus"></i></div>
                                                            </div>
                                                        }
                                                </td>
                                                <td className="subtotal p-3 line-height-3" style={{width: "15%", paddingLeft: '5px'}}>
                                                    <h6 className="table-title text-content mb-0">Unit: {relatedProduct.companyERPUOM ? relatedProduct.companyERPUOM : relatedProduct.UOM} </h6>
                                                    <h6 className="table-title text-content">Lead Time: {relatedProduct.leadTime} </h6>
                                                </td>
                                                <td className="p-3 line-height-3 save-remove" style={{width: "10%", paddingLeft: '5px'}}>
                                                    <div className='catalogue-order-card-trash-btn' onClick={() => updateCartItems("REMOVE", item)}>
                                                        <i className="pi pi-trash" style={{fontSize: '20px'}}></i>
                                                    </div>
                                                </td>
                                            </tr>

                                            </>
                                        )
                                    
                                    })
                                }
                                
                            </tbody>
                        </table>
                    }
                    <br/>
                    {cartItems.length == 0 ? '' : 
                        <div className=" flex flex-row justify-content-end mt-2">
                            <Button className="clear-cart-button" style={{height: '27px', marginBottom: '15px', lineHeight: '28px', fontSize: '13px', backgroundColor:"#26a69a", border:"#26a69a"}} label="CLEAR CART" onClick={() => updateCartItems("CLEAR")} />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default CartItems;